export const environment = {
  production: true,
  loadPlayground: false,

  baseUrl: 'http://localhost:8081/rest/api',
  companyName: 'Codemers GmbH',
  companyStreet: 'Wawitz 21',
  companyCity: '02627 Hochkirch',
  appName: 'FE',
  companyEmail: 'info@codemers.de',
  companyPhone: '+49 12 3456789'
}
